/** Tokens visuais — recebimentos do evento (marca TNV) */
export const ADIANTAMENTO_ACCENT = "#F96030";
export const ADIANTAMENTO_INK = "#1a2035";
export const ADIANTAMENTO_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const adiantamentoToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${ADIANTAMENTO_ACCENT}`,
};

export const adiantamentoModalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 720,
};

export const adiantamentoModalHeaderSx = {
  px: 2.5,
  py: 2,
  background: `linear-gradient(135deg, ${ADIANTAMENTO_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${ADIANTAMENTO_ACCENT}`,
};

export const adiantamentoSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const adiantamentoFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 44,
  },
};
